module.exports = __webpack_public_path__ + "img/FLECHE_MODIF_HEURE_POINTAGE.bf0f149f.svg";